import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemeMode = 'light' | 'dark';

export interface SystemState {
  isLoading: boolean;
  sidebarCollapsed: boolean;
  theme: ThemeMode;
  locale: string;
  message: string | null;
}

const initialState: SystemState = {
  isLoading: false,
  sidebarCollapsed: false,
  theme: 'light',
  locale: 'vi-VN',
  message: null,
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    setTheme(state, action: PayloadAction<ThemeMode>) {
      state.theme = action.payload;
    },
    setLocale(state, action: PayloadAction<string>) {
      state.locale = action.payload;
    },
    setMessage(state, action: PayloadAction<string | null>) {
      state.message = action.payload;
    },
    resetSystem(state) {
      state.isLoading = false;
      state.sidebarCollapsed = false;
      state.theme = 'light';
      state.locale = 'vi-VN';
      state.message = null;
    },
  },
});

export const {
  setLoading,
  setSidebarCollapsed,
  setTheme,
  setLocale,
  setMessage,
  resetSystem,
} = systemSlice.actions;

export default systemSlice.reducer;
